var Pandora = Pandora || {};

// Keeps the distribution planner on one page: switching scope and reviewing changes both re-render
// only the section, so weights typed into the table are never lost to a full reload.
//
// The preview itself stays on the server. Shares and offsets are computed by the Kam models, so
// duplicating that maths here would let the summary drift from what a save actually does.
Pandora.KamDistributionHandler = {
  SECTION_SELECTOR: '#kam-distribution-section',
  SCOPE_SELECTOR: '#kam-distribution-scope',
  FORM_SELECTOR: '.js-kam-distribution-form',
  SELECT_SELECTOR: '.js-kam-select',
  SELECT2_INITIALISED_CLASS: 'select2-hidden-accessible',

  init: function(sectionUrl) {
    this._sectionUrl = sectionUrl;

    var $section = $(this.SECTION_SELECTOR);
    if (!$section.length) return;

    // Delegated from document so the handlers survive every re-render of the section.
    $(document).on('change', this.SCOPE_SELECTOR, $.proxy(this._onScopeChange, this));
    $(document).on('submit', this.FORM_SELECTOR, $.proxy(this._onReview, this));

    // The scope form only exists as a no-JS fallback; the select alone drives it now.
    $('.js-kam-distribution-scope-submit').hide();

    this._enhanceSelects();
  },

  // select2 is initialised on page load, so anything injected afterwards stays a plain select
  // until it is enhanced here.
  _enhanceSelects: function() {
    if (!$.fn.select2) return;

    $(this.SECTION_SELECTOR)
      .find(this.SELECT_SELECTOR)
      .not('.' + this.SELECT2_INITIALISED_CLASS)
      .select2({ width: '300px' });
  },

  _onScopeChange: function(event) {
    this._load($.param({ scope: $(event.currentTarget).val() }));
  },

  _onReview: function(event) {
    event.preventDefault();
    this._load($(event.currentTarget).serialize());
  },

  _load: function(query) {
    var $section = $(this.SECTION_SELECTOR);
    $section.css('opacity', 0.5);

    fetch(this._sectionUrl + '?' + query, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    })
      .then(function(response) { return response.text(); })
      .then($.proxy(function(javascriptResponse) {
        eval(javascriptResponse);
        this._enhanceSelects();
        $section.css('opacity', 1);
      }, this))
      .catch(function() {
        // Fall back to a normal navigation rather than leaving a half-faded, stale table.
        $section.css('opacity', 1);
        window.location.search = '?' + query;
      });
  }
};
